import styled from 'styled-components';
import {injectAdaptive} from 'ui/theme';

export const Section = styled.div`
  padding: 10px 0 20px;
  border-top: 2px solid ${(p) => p.theme.lightTransparent};
  ${injectAdaptive('padding-bottom', ['15px', '15px', '20px', '20px', '20px'])};

  &.income,
  &.refill {
    color: ${(p) => p.theme.green};
  }
`;
